import { HeadingSM, HeadingXL, TitleMD } from '@/atoms/Text'
import { useAboutContext } from '@/contexts/AboutContext'
import { useTranslate } from '@/utils/translate/translate-client'

type ImpactType = {
  description: string
  value: string
}

const ImpactCard = (data: ImpactType) => {
  return (
    <div className="flex flex-col gap-2 rounded-3xl bg-gray-900 px-8 py-14 text-left">
      <HeadingXL className="md:photon-display overflow-hidden text-clip" weight="bold">
        {data.value}
      </HeadingXL>
      <TitleMD color="gray-500" weight="semibold">
        {data.description}
      </TitleMD>
    </div>
  )
}

export const OurImpactSection = () => {
  const { t } = useTranslate('about')
  const { impact } = useAboutContext()
  const { numberOfGuildMembers } = useAboutContext()
  const guildMemberIndex = impact.customData.findIndex((data: ImpactType) => data.description === 'Angel Guild Members')
  impact.customData[guildMemberIndex].value = numberOfGuildMembers

  return (
    <section className="bg-black py-32 text-center">
      <HeadingSM className="pb-16" weight="bold">
        {t('ourImpact', 'Our Impact')}
      </HeadingSM>

      <div className="mx-auto grid w-full max-w-[1800px] grid-cols-1 gap-4 px-8 md:grid-cols-2 lg:px-32 2xl:grid-cols-4">
        {impact.customData.map((data: ImpactType, index: number) => {
          return <ImpactCard key={`impact-${index}`} {...data} />
        })}
      </div>
    </section>
  )
}
